import CropImage from 'core/modules/components/CropImage/CropImage';
import { Dialog } from 'ui';
import React from 'react';
import useDialogPhoto from './useDialogPhoto';

type DialogPhotoProps = {
  item: any;
  onRefresh?: () => void;
  open: boolean;
  program: any;
  setOpen: (open: boolean) => void;
  t: (key: string) => string;
  update?: (data: any) => void;
};

function DialogPhoto({ item, onRefresh = () => null, open, program, setOpen, t, update = () => null }: DialogPhotoProps): JSX.Element {
  const title = t('common:Add an image');
  const buttonTextSucess = t('actions:Save');
  const { photo, url, onChangePhoto, onCloseModal, onSuccess, setPhoto } = useDialogPhoto({ open, onRefresh, program, item, setOpen, update });

  return (
    <Dialog
      buttonTextSuccess={buttonTextSucess}
      className="program-form-contents-dialog-post"
      // isDisabledSuccess={!photo}
      onCancel={onCloseModal}
      onClose={onCloseModal}
      onSuccess={onSuccess}
      isOpen={open}
      size="m"
      title={title}
    >
      <CropImage
        hasImage={true}
        onChange={onChangePhoto}
        setImage={setPhoto}
        subTitle={t('common:Formats PNG/JPG')}
        title={t('common:Upload file')}
        titleDialogCrop={t('common:Confirm image')}
        url={url}
      />
    </Dialog>
  );
}

export default DialogPhoto;
